import { EMAIL_CONFIRMATION, REQUEST } from 'constants/actions';

export default function emailConfirmation(token) {
  return { type: EMAIL_CONFIRMATION + REQUEST, token };
}
